import React, { Component } from 'react';
import '../../../src/styles/Journals.css';
import { Link } from 'react-router-dom';
import { appService } from '../../_services';
import DocumentMeta from 'react-document-meta';
import queryString from 'query-string'; //Start:Pradip Lalvani -Tab
import { Maintenance } from '../Maintenance/Maintenance.jsx';
import ReactGA from 'react-ga';
let url = '', params = '', path = '', useragent = navigator.userAgent;
let meta = '', subscribedData = '', unSubscribedData = '';
var lengthy;
var Desc;
var StyleEle = {
    lineHeight: '20px'
}

var ShortStyleEle = {
    lineHeight: '23px'
}

var StyleElem = {
    lineHeight: '0px'
}

var StyleSet = {
    marginBottom: '0px',
    //marginTop: '12px'
}

var Borderpadding = {
    padding: '1% 0% 1% 1%',
    height: null
}

var heightSet = {
    height: '199px'
}

var Imgstyle = {
    //  height: '112px',
    //  width: '90px'
}

var paddingLeftProp = {
    padding: '0% 0% 0% 2%'
}
var latestissuepad = {
    paddingLeft: '5%'
}

var latestissueListpad = {
    paddingLeft: '2%'
}

let subscribedArray = '', otherSubscribedArray = '', isSubscribe = '' //Pradip Lalvani
export class AllEncyclopedias extends Component {
    displayName = AllEncyclopedias.name
    constructor(props) {
        super(props);
        this.state = {
            login: false,
            pagedesc: '',
            Display: false,
            Subscribed: false, IsError: false
        }
        this.state = {
            items: [],
            EncycloList: [],
            list: [
                { value: "", name: "All content", isChecked: true },
                { value: "Journal", name: "All journals", isChecked: false },
                { value: "Encyclopaedia", name: "All encyclopaedias", isChecked: false },
                { value: "Manual", name: "All manuals", isChecked: false },
                { value: "mysubscription", name: "Your subscriptions", isChecked: false },
            ]
        }
        //End: Pradip Lalvani -Tab
        this.listView = this.listView.bind(this);
        this.gridView = this.gridView.bind(this);
        this.SortByValue = this.SortByValue.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
    }


    handleSelect(e) {
        window.scrollTo(0, 0);
    }


    SortByValue(e) {
        var self = this;
        appService.getById('Product/GetAllEncyclopedia?SortBy=', e.target.value)
            .then(function (data) {
                if (data == "Error found") {
                    //window.location = "/Maintenance";
                    self.setState({ IsError: true });
                }
                else {
                   
                    self.setState({ items: data, EncycloList: data });
                }
            });
        
    }

    stingBreakLine(str, length, ending) {
        //str = str.props.dangerouslySetInnerHTML.__html;

        if (length == null) {
            length = 100;
        }
        if (ending == null) {
            ending = '...';
        }
        if (str != null && str.length > length) {
            return str.substring(0, length - ending.length) + ending;
        } else {
            return str;
        }
    };

    checkTitleLenght(str) {
        if (str.length > 25) {
            this.inputDigit(80);
        }
        else {
            this.inputDigit(100);
        }
    };

    inputDigit(digit) {
        this.setState({
            displayValue: String(digit)
        });
    }


    componentDidMount() {

        var self = this;
        //Pradip Lalvani
        if (localStorage.getItem('user') !== null) {
            this.state.login = true;
        }
        else {
            this.state.login = false;
        }

        //Start : Pradip Lalvani
        appService.getById('Product/GetAllEncyclopedia?SortBy=AZ&username=', JSON.parse(localStorage.getItem('user')))
            .then(function (encyclopedias) {
                //console.log(encyclopedias)
                if (encyclopedias == "Error found") {
                    // window.location = "/Maintenance";
                    self.setState({ IsError: true });
                }
                else {
                    self.setState({ items: encyclopedias, EncycloList: encyclopedias });
                    self.state.EncycloList.map((items) => {

                        self.setState({ Subscribed: items.subscribed });
                    })


                   
                }
            });


        appService.getAll('AppData/GetAppData?fieldName=encyclopedia page description').then(function (data) {
            if (data == "Error found") {
                // window.location = "/Maintenance";
                self.setState({ IsError: true });
            }
            else {
                self.setState({ pagedesc: data.value });
              
            }
            // console.log(self.state.pagedesc);
        });
        if (localStorage.getItem('user') !== null) {
            window['NTPT_PGEXTRA'] = 'user_id=' + localStorage.getItem('salesForceID') + '&user=' + localStorage.getItem('user') + '&platform=klo &useragent=' + useragent;
            const script = document.createElement("script");
            script.src = "/siqpagetag.js";
            script.async = true;
            document.body.appendChild(script);
        }
        else {
            window['NTPT_PGEXTRA'] = '&platform=klo &useragent=' + useragent;
            const script = document.createElement("script");
            script.src = "/siqpagetag.js";
            script.async = true;
            document.body.appendChild(script);
        }

        var msg = {
            ArticleTitle: window['NTPT_PGEXTRA']
        }
        var Logurl = 'Product/LogData';
        appService.submit(Logurl, msg).then(function (data) {

        });

        ReactGA.initialize(
            [
                {
                    trackingId: 'UA-2905701-8',
                    gaOptions: { name: 'tracker1' }
                },
                {
                    trackingId: 'UA-72849501-2',
                    gaOptions: { name: 'tracker2' }
                }
            ],
            { alwaysSendToDefaultTracker: false }
        );

        ReactGA.pageview(window.location.pathname, ['tracker1', 'tracker2'], "Kluwer Law Online - Encyclopaedias");

        var metas = document.getElementsByTagName('meta');
        for (let i = 0; i < metas.length; i++) {
            if (metas[i].getAttribute('name') == "robots") {
                console.log(metas[i]);
                metas[i].remove();
            }
        }
    }

    componentWillMount() {
        this.setState({ items: this.state.EncycloList })
    }

    SearchPublication = (e) => {
        var updatedList = this.state.EncycloList;
        updatedList = updatedList.filter(function (item) {
            return item.title.toLowerCase().search(
                e.target.value.toLowerCase()) !== -1;
        });
        this.setState({ items: updatedList });
    }

   
    listView = () => {

        //var elements = document.getElementsByClassName("col-lg-4");
        var element = document.getElementsByName("GridList");

        for (var i = 0; i < element.length; i++) {
            element[i].classList.remove("col-lg-4");
            element[i].classList.add("col-lg-12");

        }
        var Borderelements = document.getElementsByClassName("Border");

        for (var k = 0; k < Borderelements.length; k++) {
            Borderelements[k].style.padding = "1% 0% 1% 1%";
            Borderelements[k].style.height = null;

        }
        var TitlePadding = document.getElementsByClassName("paddingL");
        for (var H = 0; H < TitlePadding.length; H++) {
            TitlePadding[H].style.padding = "0% 0% 0% 2%";

        }

        var Imgelements = document.getElementsByClassName("JounrnalImg");

        for (var l = 0; l < Imgelements.length; l++) {
            // Imgelements[l].style.height = "112px";
            // Imgelements[l].style.width = "90px";

        }
        this.setState({
            Display: true
        });

    }
    gridView = () => {

        //var elements = document.getElementsByClassName("col-lg-4");
        var element = document.getElementsByName("GridList");


        for (var i = 0; i < element.length; i++) {
            element[i].classList.remove("col-lg-12");
            element[i].classList.add("col-lg-4");


        }

        var Borderelements = document.getElementsByClassName("Border");

        for (var j = 0; j < Borderelements.length; j++) {
            Borderelements[j].style.padding = "3% 0% 3% 3%";

        }

        var TitlePadding = document.getElementsByClassName("paddingL");
        for (var H = 0; H < TitlePadding.length; H++) {
            TitlePadding[H].style.padding = "0% 0% 0% 10%";

        }

        var Imgelements = document.getElementsByClassName("JounrnalImg");

        for (var l = 0; l < Imgelements.length; l++) {
            // Imgelements[l].style.height = "85%";

        }
        this.setState({
            Display: false
        });

    }
    render() {
        if (this.state.IsError != true) {
            var container = document.getElementById("btnContainer");

            if (container !== null) {
                var btns = container.getElementsByClassName("btn");
                for (var k = 0; k < btns.length; k++) {
                    btns[k].addEventListener("click", function () {
                        var current = document.getElementsByClassName("activeClick");
                        current[0].className = current[0].className.replace(" activeClick", "");
                        this.className += " activeClick";
                    });
                }

            }

            //Start:Pradip Lalvani
            const onlineSubscribed = this.state.items;
            subscribedArray = onlineSubscribed.filter(item => item.subscribed == true);

            const otherSubscribed = this.state.items;
            otherSubscribedArray = otherSubscribed.filter(item => item.subscribed != true)
            if (subscribedArray.length > 0) {
                isSubscribe = 1
            }
            subscribedData = subscribedArray.map((item, key) => {
                var Checkclass = document.getElementById("Gridbtn").classList.contains("activeClick");
                path = "/Encyclopedias/" + item.title.replace(/ /g, "+") + "/" + item.id;
                lengthy = item.title.length;
                return <div name="GridList" className={(Checkclass == true) ? "col-lg-4 Gridcolumn" : "col-lg-12 Gridcolumn"}>
                    <div className="Border" style={(Checkclass == true) ? heightSet : Borderpadding}>
                        <Link to={"/PracticeArea?Id=" + item.topicId + "&name=" + item.topic.replace(/ /g, "+")}><h1 className="HomepageHeading"><img alt={"Cover Image for " + item.title} src="/../../images/green-arrow.png" />
                            <span style={{ paddingLeft: '7px' }}>{item.topic}</span></h1></Link>
                        <div className="JournalFlex" style={{ paddingRight: '3%' }}>
                            <Link to={path} onClick={this.handleSelect}> <img alt={"Cover Image for " + item.title} src={"/../../images/books/" + item.imageUrl} className="JounrnalImg" style={(Checkclass == true) ? null : Imgstyle} /></Link>
                            <div style={{ width: '100%' }}>
                                <h2 className="paddingL JournalTitle" style={(Checkclass == true) ? null : paddingLeftProp}> <Link to={path} style={lengthy > 22 && lengthy < 48 ? StyleEle : lengthy >= 48 ? StyleElem : ShortStyleEle} onClick={this.handleSelect} dangerouslySetInnerHTML={{ __html: item.title }}></Link></h2>


                                <p style={(Checkclass == true) ? null : paddingLeftProp} className="paddingL journalbody">
                                    {this.state.Display == true ? this.stingBreakLine(item.description, 250, '.....') : this.stingBreakLine(item.description, item.containLenght, '.....')}
                                    <br></br>
                                </p>

                                <div style={lengthy > 48 ? StyleSet : null}>
                                    <Link style={(Checkclass == true) ? latestissuepad : latestissueListpad} onClick={this.handleSelect} to={"/EncyclopediaChapter/" + item.title.replace(/ /g, "+") + "/" + item.latestProductDocId} className="LinkClass">Latest chapter</Link>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            });
            unSubscribedData = otherSubscribedArray.map((item, key) => {

                var Checkclass = document.getElementById("Gridbtn").classList.contains("activeClick");
                path = "/Encyclopedias/" + item.title.replace(/ /g, "+") + "/" + item.id;
                lengthy = item.title.length;
                return <div name="GridList" className={(Checkclass == true) ? "col-lg-4 Gridcolumn" : "col-lg-12 Gridcolumn"}>
                    <div className="Border" style={(Checkclass == true) ? heightSet : Borderpadding}>
                        <Link to={"/PracticeArea?Id=" + item.topicId + "&name=" + item.topic.replace(/ /g, "+")}><h1 className="HomepageHeading"><img alt="" src="/../../images/green-arrow.png" />
                            <span style={{ paddingLeft: '7px' }}>{item.topic}</span></h1></Link>
                        <div className="JournalFlex" style={{ paddingRight: '3%' }}>
                            <Link onClick={this.handleSelect} to={path}> <img alt={"Cover Image for " + item.title} src={"/../../images/books/" + item.imageUrl} className="JounrnalImg" style={(Checkclass == true) ? null : Imgstyle} /></Link>
                            <div style={{ width: '100%' }}>
                                <h2 className="paddingL JournalTitle" style={(Checkclass == true) ? null : paddingLeftProp}> <Link to={path} style={lengthy > 22 && lengthy < 48 ? StyleEle : lengthy >= 48 ? StyleElem : ShortStyleEle} onClick={this.handleSelect} dangerouslySetInnerHTML={{ __html: item.title }}></Link></h2>

                                <p className="paddingL journalbody" style={(Checkclass == true) ? null : paddingLeftProp}>
                                    {this.state.Display == true ? this.stingBreakLine(item.description, 250, '.....') : this.stingBreakLine(item.description, item.containLenght, '.....')}
                                    <br></br>

                                </p>
                                <div style={lengthy > 48 ? StyleSet : null}>
                                    <Link style={(Checkclass == true) ? latestissuepad : latestissueListpad} onClick={this.handleSelect} to={"/EncyclopediaChapter/" + item.title.replace(/ /g, "+") + "/" + item.latestProductDocId} className="LinkClass">Latest chapter</Link>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            });
            meta = {
                title: "Kluwer Law Online - Encyclopaedias",
                //description: "Peer-reviewed monographs provide practical information and valuable insights into both national and international legal frameworks in 25 practice areas",
                canonical: window.location.href,
                //meta: {
                //    charset: "utf-8",
                //    name: {
                //        title: "International Encyclopeadia of Laws | Kluwer Law Online",
                //        description: "Peer-reviewed monographs provide practical information and valuable insights into both national and international legal frameworks in 25 practice areas"
                //    }
                //}
            }
        }
        return (
            this.state.IsError != true ?
                <DocumentMeta {...meta}>
                    <div>
                        <div className="col-12">
                            <div className="row">
                                <div className="col-lg-9">
                                    <h1 className="colPadding Title">International Encyclopaedia of Laws</h1>
                                    <div className="colPadding IntroText" dangerouslySetInnerHTML={{ __html: this.state.pagedesc }}></div>
                                </div>
                            </div>

                            <div className="row margintop" style={{ width: '99%' }}>
                                <div className="col-lg-5 colPadding">
                                    <input className="form-control RefineListWords" id="ex3" type="text" title="Refine list by words in title" onChange={this.SearchPublication} placeholder="Refine list by words in title" />
                                </div>

                                <div className="col-lg-7 colPadding">
                                    <div className="row">
                                        <div className="col-lg-3 setmarginrss Setjournalmargin">
                                            <div className="dropdown">
                                                <select className="dropbtn DropDownArrow" title="Sort results by" onChange={this.SortByValue} style={{ width: '125px', paddingLeft: '5%' }} id="SortDropDwn">
                                                    <option selected value="AZ">A-Z</option>
                                                    <option value="PA">Practice Area</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 Setjournalmargin">
                                            <div id="btnContainer" className="btn-group">
                                                <button id="Gridbtn" className="btn GridlistBtn activeClick" title="Select for grid view" data-tooltip="Select for grid view" onClick={this.gridView} style={{ color: 'darkgrey' }}><i className="fa fa-th" style={{ fontSize: '40px', verticalAlign: 'text-top' }}></i></button>
                                                <button id="Listbtn" className="btn GridlistBtn" title="Select for list view" data-tooltip="Select for list view" onClick={this.listView} style={{ color: 'darkgrey' }}><i className="fa fa-bars" style={{ fontSize: '40px' }}></i></button>
                                            </div>

                                        </div>
                                        <div className="col-lg-1 RSSCard Setjournalmargin" data-tooltip="RSS feed for all encyclopaedia titles">
                                            <a style={{ cursor: 'pointer' }} href={'feeds/' + "AllEncyclopedias"} target="_blank" className="LinkClass">
                                                <img alt="" src="/../../images/Rss-Default.png" />
                                                <img alt="" src="/../../images/Rss-Hover.png" class="img-top" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {this.state.login && isSubscribe == 1 && subscribedArray.length > 0 ?
                                <div className="row margintop" id="LoginJournal">
                                    <div className="col-lg-12 colPadding">  <hr style={{ width: '98%', float: 'left' }}></hr> </div>
                                </div>
                                : null}
                            {this.state.login && isSubscribe == 1 && subscribedArray.length > 0 ?
                                <div className="row" id="LoginJournalhdr">
                                    <div className="col-lg-9">
                                        <h1 className="LawHeader colPadding">Your online encyclopaedias </h1>
                                    </div>
                                </div>
                                : null}

                            <div className="col-12" style={{ width: '94%' }}>
                                {this.state.login && isSubscribe == 1 && subscribedArray.length > 0 ?
                                    <div className="BGGrey">
                                        <div className="row rowmrg">
                                            {subscribedData}
                                        </div>
                                    </div>
                                    : null}
                                {this.state.login && otherSubscribedArray.length > 0 ?
                                    <div className="row" id="LoginAvailableJournal">
                                        <h1 className="LawHeader">Other available encyclopaedias</h1>
                                    </div>
                                    : null}
                                {(this.state.login == true || this.state.login == false) ?
                                    <div>
                                        {(this.state.login == false) ?
                                            <br></br>
                                            :
                                            null
                                        }
                                        <div className="BGGrey" id="LoginJournalgrid">
                                            <div className="row rowmrg">
                                                {unSubscribedData}
                                            </div>
                                        </div>
                                    </div>
                                    : null}
                            </div>
                            <div className="White">
                            </div>
                        </div>

                    </div>
                </DocumentMeta>
                :
                <Maintenance />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Encyclopedias/AllEncyclopedias.jsx